import { createComponent } from "@helpers/admin";
import CTASectionComponent from "@template/blocks/CTASection/component";

export const Cta = createComponent({
  label: "CTA Banner",
  component: CTASectionComponent,
  fields: {
    heading: {
      label: "Heading",
      type: "textarea",
    },
    subHeading: {
      label: "Subheading",
      type: "textarea",
    },
    buttonText: {
      label: "Button Text",
      type: "text",
    },
    buttonLink: {
      label: "Button Link",
      type: "text",
    },
    target: {
      label: "Target",
      type: "select",
      options: [
        {
          label: "New Tab",
          value: "_blank",
        },
        {
          label: "Same Tab",
          value: "_self",
        },
      ],
    },
  },
});
